// extracted by mini-css-extract-plugin
export default {"container":"adminPostSearchModule_container__JUldp","input":"adminPostSearchModule_input__m8v2M","btn":"adminPostSearchModule_btn__-99fW"};